import { BodyText, Button, FlexRow, Grid, ModalWindow } from 'ui-toolkit/index';
import { eClientContactActionType } from '../../types/contacts/eClientContactActionType';
import React from 'react';

interface IContactActionConfirmationWindowProps {
  type: eClientContactActionType;
  userName: string;
  onNoClick: () => void;
  onYesClick: () => void;
}

export const ContactActionConfirmationWindow: React.FC<IContactActionConfirmationWindowProps> = ({
  type,
  userName,
  onNoClick,
  onYesClick,
}) => {
  let text: string = '';
  switch (type) {
    case eClientContactActionType.Activate:
      text = `Activate Portal Access For ${userName}?`;
      break;
    case eClientContactActionType.Deactivate:
      text = `Deactivate Portal Access For ${userName}?`;
      break;
    case eClientContactActionType.ResetPassword:
      text = `Send Password Reset To ${userName}?`;
      break;
    case eClientContactActionType.Invite:
      text = `Send Portal Invitation Email To ${userName}?`;
      break;
    case eClientContactActionType.ReinviteUser:
      text = `Reinvite ${userName} To Portal?`;
      break;
  }
  return (
    <ModalWindow mode={'transition'}>
      <Grid>
        <BodyText>{text}</BodyText>
        <FlexRow justifyContent={'center'}>
          <Button intent={'primary'} onClick={onYesClick}>
            Yes
          </Button>
          <Button intent={'secondary'} onClick={onNoClick}>
            No
          </Button>
        </FlexRow>
      </Grid>
    </ModalWindow>
  );
};
